import { ELECTIVE_TRIGGER_VALUE } from './constants'

const ELECTIVE_OPTION = { value: ELECTIVE_TRIGGER_VALUE, label: 'Elective' }

const getEnabledPolicyCodes = (config) => {
  const raw =
    config?.policy_engine_config?.enabled_policy_codes ||
    config?.policyEngineConfig?.enabledPolicyCodes ||
    []
  return Array.isArray(raw) ? raw : []
}

const buildPolicyLookup = (schema = []) => {
  const byCode = new Map()

  schema.forEach((category) => {
    const categoryLabel = category?.displayName || category?.name || ''
    ;(category?.subCategories || []).forEach((sub) => {
      ;(sub?.policies || []).forEach((policy) => {
        if (!policy?.policyCode) return
        byCode.set(policy.policyCode, {
          name: policy.name || policy.policyCode,
          categoryLabel,
        })
      })
    })
  })

  return byCode
}

/**
 * Map tenant enabled policy codes + schema → Trigger Select options.
 * Elective is always first; policy options sorted by label.
 * value === label for policies (API filter expects names like "Email Address (HIPAA)").
 */
export const mapTriggerFilterOptions = (schema = [], config = null) => {
  const enabledCodes = getEnabledPolicyCodes(config)
  const lookup = buildPolicyLookup(schema)

  const policyOptions = enabledCodes
    .map((code) => {
      const match = lookup.get(code)
      if (!match) return null
      const label = match.categoryLabel ? `${match.name} (${match.categoryLabel})` : match.name
      return { value: label, label }
    })
    .filter(Boolean)
    .sort((a, b) => a.label.localeCompare(b.label))

  return [ELECTIVE_OPTION, ...policyOptions]
}
